<script lang="ts">
	import MaskInstance from "./MaskInstance.svelte"
	import { getContext } from "svelte"
	import { SidebarController } from "./SidebarController.svelte"
	import { CollapsibleSectionNoBind, LoadingSpinner } from "misc-ui"
	import { ImageModifierController } from "../ImageModifierController.svelte"
	import { MaskBase } from "luxedo-canvas/asset"

	let controller = getContext<ImageModifierController>("controller")

	let imageSrc = $derived(controller.imagePath)
	let imageRes = $derived(controller.imageResolution)

	let isLoadingMasks = $derived(controller.isLoadingMasks)
	let allMasks = $derived(controller.availableMasks)
	let selectedMasks = $derived(controller.selectedMasks)
	let maskAmount = $derived(selectedMasks.length)

	let expandHelp = $derived(SidebarController.showDetails)

	$inspect(selectedMasks)

	function selectMask(mask: MaskBase) {
		let isSelected = controller.selectedMasks.find((m) => m.id === mask.id)

		if (isSelected) return controller.deselectMask(mask)
		return controller.selectMask(mask)
	}

	async function triggerNewMask() {
		SidebarController.setView("new-mask")
	}

	async function editMask(calMask: MaskBase) {
		controller.editMask(calMask)
		SidebarController.setView("edit-mask")
	}

	function initiateRemove() {
		controller.triggerRemoval()
	}
</script>

<CollapsibleSectionNoBind expanded={expandHelp} onclick={SidebarController.toggleDetails}>
	{#snippet header()}
		<div class="heading">
			<h3>Select masks</h3>
			<button class="info-heading link-button small">{expandHelp ? "Hide" : "More"} details</button>
		</div>
	{/snippet}
	{#snippet content()}
		<ol>
			<li>
				First, create a mask around your entire building/projection space
				<p class="info">This defines the overall area where projections can appear</p>
			</li>
			<li>
				<strong>Optionally</strong>, add masks for sections you <strong>DON'T</strong> want to
				project onto
				<p class="info">Skip this step if you want projections to cover your entire space.</p>
			</li>
			<li>
				Click continue
				<p class="info">You must select at least one mask to move to the next step</p>
			</li>
		</ol>
	{/snippet}
</CollapsibleSectionNoBind>
<hr />
<div class="all-masks expand">
	{#if allMasks.length}
		{#each allMasks as mask (mask.id)}
			<MaskInstance
				isSelected={!!selectedMasks.find((calMask) => calMask.id === mask.id)}
				{mask}
				backgroundImageSrc={imageSrc}
				backgroundImageRes={imageRes}
				onEdit={() => editMask(mask)}
				onClick={() => selectMask(mask)}
			/>
		{/each}
	{:else if isLoadingMasks}
		<p>Loading masks... <LoadingSpinner height="1rem" color="var(--color-main)" /></p>
	{:else}
		<p>You haven't created any masks for this snapshot, click "New Mask" below to get started.</p>
	{/if}
</div>
<div class="button-container">
	<button class="outline-button sidebar-button warn" onclick={controller.onCancel}>← Go Back</button
	>
	<div class="flex-row">
		<button class="outline-button sidebar-button alt" onclick={triggerNewMask}>New Mask</button>
		{#if maskAmount}
			<button class="outline-button sidebar-button" onclick={initiateRemove}>Continue</button>
		{/if}
	</div>
</div>

<style>
	.all-masks {
		flex-grow: 1;
		overflow-y: scroll;
		padding: 0 0.5rem 0 0;
		margin-bottom: 1rem;
	}

	p {
		line-height: 1.25rem;
	}

	.flex-row {
		width: 100%;
		gap: 0.5rem;
	}

	.flex-row button {
		flex-grow: 1;
	}
</style>
